import { createEnv } from "@t3-oss/env-core";
import { z } from "zod";

export const env = createEnv({
  clientPrefix: "VITE_",

  client: {
    VITE_AUTH0_CLIENT_ID: z.string().min(1),
    VITE_AUTH0_DOMAIN: z.string().min(1),
    VITE_PROJECT_TITLE: z.string().min(1),
    VITE_PROJECT_CODE: z.string().min(1),
    VITE_ENVIRONMENT: z.enum(["local", "dev", "stg", "prod", "ci", "feat", "sandpit"]),
    VITE_CUSTOMER_ID_KEY: z.string().min(1),
    VITE_THEME_KEY: z.string().min(1),
    VITE_API_URL: z.url(),
    VITE_TOKEN_URL: z.url(),
    VITE_BASE_DOMAIN_URL: z.string().min(1),
  },

  runtimeEnv: import.meta.env,

  emptyStringAsUndefined: true,
});
